import {onMounted, ref, watch} from "vue";
import Accommodation from "../../lib/models/Accommodation";
import {useState} from "#app";

export function useStateFunctionViewed() {
    const viewed = useState<Array<Object>>('viewed-items', () => []);

    const addToViewed = (obj) => {
        removeFromViewed(obj);
        viewed.value.push(obj);
    };

    onMounted(() => {
        const stored = localStorage.getItem('viewed-items') as string;
        try {
            if (typeof stored === 'string' && JSON.parse(stored)) {
                viewed.value = JSON.parse(stored).filter(i => i.id > 0);
            }
        } catch (e) {

        }

    });

    watch(viewed, (val) => {
        if (process.client) {
            localStorage.setItem('viewed-items', JSON.stringify(val));
        }
    })


    const removeFromViewed = (obj: any) => {
        viewed.value = viewed.value.filter(item => {
            if (item.hasOwnProperty("id") && obj.hasOwnProperty("id")) {
                return item.id !== obj.id;
            } else if (item.hasOwnProperty("_id") && obj.hasOwnProperty("_id")) {
                return item._id !== obj._id;
            } else {
                return JSON.stringify(item) !== JSON.stringify(obj);
            }
        });
    }

    return {viewed: viewed, addToViewed, removeFromViewed}
}
